import { render, staticRenderFns } from "./tv.vue?vue&type=template&id=ffd2df64&scoped=true&"
import script from "./tv.vue?vue&type=script&lang=js&"
export * from "./tv.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/data/tv.less?vue&type=style&index=0&id=ffd2df64&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffd2df64",
  null
  
)

component.options.__file = "tv.vue"
export default component.exports